import api from '@/api'
import router from '@/router'

var Q = require('q')

const state = {
  idUsuario: null,
  accessToken: null
}

const getters = {
  idUsuario: (state) => state.idUsuario,
  accessToken: (state) => state.accessToken
}

const mutations = {
  SET_ID_USUARIO (state, idUsuario) {
    state.idUsuario = idUsuario
  },
  SET_ACCESS_TOKEN (state, token) {
    state.accessToken = token
  }
}

const actions = {
  login: async function ({ commit, dispatch }, credentials) {
    var deferred = Q.defer()

    try {
      const response = await api.auth.login(credentials)

      const { ID_USUARIO, TOKEN } = response.data
      commit('SET_ID_USUARIO', ID_USUARIO)
      commit('SET_ACCESS_TOKEN', TOKEN)
      // dispatch('setAccessToken', response.data)

      deferred.resolve()
    } catch (e) {
      console.error('Error login', e)
      deferred.reject() // e.response
    }

    return deferred.promise
  },

  logout ({ commit, dispatch }, tokenInvalid) {
    // dispatch('setAccessToken', null)
    commit('SET_ACCESS_TOKEN', null)

    if (!tokenInvalid) {
      router.push('/login')
    } else {
      router.push({ path: 'login', query: { reason: 'token_invalid' } }).catch(() => {})
    }
  },

  setAccessToken ({ commit }, token) {
    commit('SET_ACCESS_TOKEN', token)
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
